import cogoToast from 'cogo-toast';
import { takeLatest, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import {
  VALIDATE_UTILITY_ATTACHMENTS,
  VALIDATE_UTILITY_ATTACHMENTS_SUCCESS,
  VALIDATE_UTILITY_ATTACHMENTS_ERROR,
} from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* validateUtilityAttachments({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    // Booking modification validates on its own route, with the booking type in the path and its own file field.
    const isBookingModification = payload.issueType === 'booking_modification';

    const formData = new FormData();
    if (isBookingModification) {
      formData.append('bulk-booking-modification-file', payload.file);
    } else {
      formData.append('issue-type', payload.issueType);
      formData.append('utility-request-attachments', payload.file);
      if (payload.bookingType) formData.append('booking_type', payload.bookingType);
    }

    const response = yield call(apiCall, {
      url: isBookingModification
        ? `${adminAPIURL}/v2/utility-request/booking-modification/validate/${payload.bookingType}`
        : `${adminAPIURL}/v2/utility-request/validate-attachments`,
      method: 'POST',
      data: formData,
      isFormData: true,
      headers: filteredHeaders,
    });

    if (response.status === 200) {
      yield put({ type: VALIDATE_UTILITY_ATTACHMENTS_SUCCESS, payload: response?.data });
    } else {
      cogoToast.error(response?.response?.data?.message || 'Validation failed');
      yield put({ type: VALIDATE_UTILITY_ATTACHMENTS_ERROR, payload: response?.response?.data?.message });
    }
  } catch (error) {
    cogoToast.error('Validation failed');
    yield put({ type: VALIDATE_UTILITY_ATTACHMENTS_ERROR, payload: error });
  }
}

export function* watchValidateUtilityAttachments() {
  yield takeLatest(VALIDATE_UTILITY_ATTACHMENTS, validateUtilityAttachments);
}

function* validateUtilityAttachmentsSaga() {
  yield all([fork(watchValidateUtilityAttachments)]);
}

export default validateUtilityAttachmentsSaga;